// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js_chunk-" + {"2552":"countdown_time_interval","9166":"countdown_timer"}[chunkId] + ".js?v=" + {"2552":"312e76d83fc72a589589","9166":"c1e704789f2614c829cd"}[chunkId] + "";
};